module.exports = __webpack_public_path__ + "img/movie_student_manage_digital_paper.91ef0a3c.gif";